import React from "react";

function withAuth<T extends object>(WrappedComponent: React.ComponentType<T>): React.FC<T> {
	return function AuthenticatedComponent(props: T) {
		return <WrappedComponent {...props} />;
	};
}

export default withAuth;
